import {Component} from 'vue-property-decorator';
import Vue from 'vue';
import {Action, State} from 'vuex-class';
import {
  EntityServiceTransaction,
  FilterServiceTransaction, ServiceTransaction,
  ServiceTransactionInitState
} from '@/store/service-transaction/service-transaction.types';
import {AxiosResponse} from 'axios';
import {Toast} from '@/store/toast/toast.types';
import {MemberInitState, MemberTimeInformation, TimeInformation} from '@/store/member/member.types';
import moment from 'moment';
import {Helper} from '../../../util/helper';

@Component({
  components: {}
})
export default class CodeGeneratedComponent extends Vue {
  @State('serviceTransaction') serviceTransactionInitState!: ServiceTransactionInitState;
  @State('member') memberInitState!: MemberInitState;
  @Action('_getServiceTransactionById', {namespace: 'serviceTransaction'})
  public getServiceTransaction!: (id: string) => Promise<AxiosResponse>;
  @Action('_Toast', {namespace: 'toast'}) Toast!: (payload: Toast) => Promise<void>;
  @Action('_getTimeInformation', {namespace: 'member'}) getTimeInformation!: () => Promise<AxiosResponse>
  @Action('_Loading', {namespace: 'loading'}) Loading!: (payload: boolean) => Promise<void>;

  public filterServiceTransaction = {} as FilterServiceTransaction;
  public serviceTransaction = {} as EntityServiceTransaction;

  public view = {
    topic: ''
  };
  public timeInformation = {} as TimeInformation;
  public lib: Helper = new Helper();

  async mounted() {
    let {id} = this.$route.query;
    if (!id) {
      this.$router.push('/payment-select').then();
      return;
    }

    this.Loading(true);
    this.filterServiceTransaction.id = id as string;
    await this.getServiceTransaction(this.filterServiceTransaction.id);
    this.serviceTransaction = this.serviceTransactionInitState.serviceTransaction;

    await this.getTimeInformation();
    this.timeInformation = this.memberInitState.timeInformation.timeTransactions[0];

    // set view
    this.view.topic = `${this.serviceTransaction.subService.name} | ${this.lib.formatDateTimeThai(this.serviceTransaction.serviceDate)}`;
    this.Loading(false);

  }

  codeGenerateNextClick() {
    this.$router.push('/payment-information').then();
  }

}


